module.exports = __webpack_public_path__ + "5e0659e31eddf6f03d81f13694ae0858.svg";